import React, { useContext } from 'react';
import AppContext from '../../../contexts/AppContext';

export default function ThemesFilterComp({ onThemeChanged, themes }) {
  const { dictionnary } = useContext(AppContext);
  const [selectedThemes, setSelecteds] = React.useState([]);

  React.useEffect(() => {
    onThemeChanged(selectedThemes);
  }, [selectedThemes]);

  const setSelectedHandler = (item) => {
    const newSelection =
      themes.includes(item) && !selectedThemes.includes(item) ? [item] : [];
    setSelecteds(newSelection);
  };

  return (
    <>
      {themes.map((item) => (
        <button
          type="button"
          key={item}
          className={`main-button ${
            selectedThemes.includes(item)
              ? 'main-button--inverted'
              : 'main-button--outline'
          }`}
          onClick={() => {
            setSelectedHandler(item);
          }}
        >
          {dictionnary.get(`edit-theme-${item}`)}
        </button>
      ))}
    </>
  );
}
